// ============================================================
// web/src/features/devis/PrixCompact.jsx — LE PRIX, PENDANT QU'ON CORRIGE.
// ------------------------------------------------------------
// Deux nombres, collants, à côté de la gamme : le prix unitaire d'usinage
// et le total de la pièce. C'est ce qu'on regarde bouger en tapant un
// temps — et depuis le 7 septembre, il bouge à la frappe.
//
// ── CE QU'IL N'EST PAS ──
//
// Ce n'est PAS la synthèse. Le détail du calcul — « 180 min de montage +
// 15 min de contrôle × 80,00 €/h » — reste en pleine largeur sous la
// gamme : serré dans une colonne de 400 px, il se casse en huit lignes et
// cesse d'être vérifiable de tête (décision du 21 août 2026). Ici, deux
// chiffres et un lien vers ce détail.
// ============================================================
import { formatEuroOuTiret } from '../../lib/format.js';

export function PrixCompact({ piece, result }) {
  const unitaire = result?.price_unit ?? null;
  const total = result?.price_total ?? null;
  const horsEngagement = result?.detail?.total_hors_engagement ?? null;

  return (
    <div className="prix-compact">
      <span className="caps">Prix unitaire — usinage</span>
      <span className="prix-compact__montant num">{formatEuroOuTiret(unitaire)}</span>
      <span className="field__hint">
        {piece.qty ?? 1} pièce{(piece.qty ?? 1) > 1 ? 's' : ''} — usinage{' '}
        <strong className="num">{formatEuroOuTiret(total)}</strong>
      </span>
      {horsEngagement ? (
        <span className="field__hint">
          + matière, traitement et transport{' '}
          <span className="num">{formatEuroOuTiret(horsEngagement)}</span> — indicatif
        </span>
      ) : null}
      <span className="field__hint"><a href="#prix-detail">le détail ↓</a></span>
    </div>
  );
}

export default PrixCompact;
